/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useRef, useState } from 'react';
import styled from 'styled-components';
import { FormContext } from './Form';
import Heading from './Heading';
import { generateId } from '../utility/functions';
import TooltipHelper from './TooltipHelper';

const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1em;
    border-radius: 2em;
    transition: 0.2s;
    flex: 1;

    padding: 0.2em;
    padding-left: ${({ noPadding }) => !noPadding ? '0.5em' : ''};

    &:hover {
        background: ${({ noHover, theme }) => !noHover ? (theme.gray + '1a') : ''};
    }
`;

const CheckBoxCSS = styled.label`
    cursor: pointer;
    width: 2em;
    height: 1em;
    background-color: ${({ theme }) => theme.error}80;
    padding: 0.1em 0.1em;
    font-size: inherit;
    display: block;
	border-radius: 100px;
	position: relative;
    border: 1px solid ${({ theme }) => `${theme.gray}40`};
    transition: all 0.3s;
    display: flex;
    align-items: center;

    &:after {
        content: '';
        position: relative;
        left: 0%;
        width: 1em;
        height: 1em;
        background: ${({ theme }) => theme.input.background};
        border-radius: 90px;
        transition: 0.3s;
    }

    &:active:after {
        width: 1.1em;
        height: 1.1em;
    }

    &:disabled {
        color: ${({ theme }) => theme.input.disabledText};
        background-color: ${({ theme }) => theme.input.disabled};
        transform: unset;
        box-shadow: unset;
        cursor: default;
    }
    
`;

const InputCSS = styled.input`
    opacity: 0;
    position: absolute;
    width: 0;
    height: 0;
    cursor: inherit;
    &:checked + label {
        background: ${({ theme }) => theme.active};
    }

    &:checked + label:after {
        left: calc(100% - (0.6em + 0.4em));
    }

    &:disabled + label:after {
        background: ${({ theme }) => theme.black}40;
    }
    &:focus + label {
        outline: none !important;
        border: 1px solid ${({ theme }) => theme.text};
        box-shadow: 0 0 3px ${({ theme }) => theme.highlight};
    }
`;
const Tag = styled.sup`
    position: absolute;
    font-size: 0.5em;
    margin: 0 0 0em 1em;
`;
const Error = styled(Tag)`
    color: ${({ theme }) => theme.error};
`;


const Checkbox = ({ context, ...props }) => {
    const inputRef = useRef();
    const checkboxRef = useRef();
    const [invalid, setInvalid] = useState(false);
    const [invalidMessage, setInvalidMessage] = useState('');
    const [id] = useState(generateId());

    const handleChange = (e) => {
        e = e.target.checked;

        if (context.values[props.name] instanceof Array) {
            handleSelectionChange()
        } else {
            context.setValues(v => {
                return {
                    ...v,
                    [props.name]: e
                }
            })
        }
        if (props.callback)
            props.callback(e)
    }

    const handleSelectionChange = () => {
        const { name, value } = props;
        const values = context.values[name];

        context.setValues(v => ({
            ...v,
            [name]: values.includes(value)
                ? values.filter(e => e !== value)
                : [...values, value]
        }));
    };

    const disabled = context ? context.submitting || context.editing || props.disabled : props.disabled;

    return props.standalone ? (
        <Wrapper noHover={props.noHover} noPadding={props.noPadding}>
            {props.label &&
                <Heading
                    fontSize={0.8}
                    htmlFor={props.name + id}
                    style={{ width: '90%', lineHeight: '2em', cursor: disabled ? 'unset' : 'pointer' }}
                >
                    {props.label}
                    {context && <TooltipHelper formName={context.formName} name={`${props.name}_${props.value || 'checkbox'}`} />}
                </Heading>
            }
            <InputCSS
                ref={inputRef}
                type='checkbox'
                checked={
                    (context
                        ? context.values[props.name] instanceof Array
                            ? (context.values[props.name].includes(props.value))
                            : (context.values[props.name])
                        : props.value)
                    || false
                }
                onChange={context && handleChange}
                id={props.name + id}
                onFocus={() => checkboxRef.current.focus()}
                disabled={disabled}

                onClick={e => { if (props.inputClick) props.inputClick(e.target) }}
                {...props}
            />
            <CheckBoxCSS
                ref={checkboxRef}
                htmlFor={`${props.name + id}`}
                disabled={disabled}
                {...props}
            />
            {invalid && <Error>{invalidMessage || props.error}</Error>}
        </Wrapper>
    ) : (
        <InputContext
            standalone={1}
            {...props}
        />
    );
}

export default Checkbox;


const InputContext = ({ ...props }) => {
    const context = useContext(FormContext);
    return (
        <Checkbox
            context={{ ...context }}
            {...props}
        />
    )
}
